import styled from "styled-components";

const CardDiv = styled.div`
  background: linear-gradient( to right,  var(--Text500), #F8F9FE );
  -webkit-text-fill-color: transparent; 
  -webkit-background-clip: text;
  background-clip: text;
`

const Tab = styled.div`
  margin-right: ${({ last }) => !last ? '48px' : '0'};
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  color: ${({ theme, active }) => active ? theme.colors.interactive.azure2 : theme.colors.text.text300};
  @media (max-width: 600px) {
    margin-right: ${({ last }) => !last ? '24px' : '0'};
  }
`

const TabNameSpan = styled.span`
  white-space: nowrap;
  padding: 7px 12px;
  margin-top: -6px;
  margin-left: -11px;
  &:hover {
    border-radius: 4px;
    background-color: #f0f1f5;
  }
  @media (max-width: 600px) {
    padding: 0;
    margin-left: 0;
    margin-top: -2px;
    &:hover {
      background-color: unset;
    }
  }
`
const TopWalletSection = styled.div`
  display: flex;
  justify-content: space-between;
`

const BalanceRightSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: end;
`
const IncomeRightSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`
const TotalEarningLabel = styled.div`
  font-size: 16px;
  line-height: 1.5;
  text-align: left;
  color: var(--Text700);
`
const SingleDivSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`
const EarningText = styled(TotalEarningLabel)`
  font-size:12px;
`
const TabsHolder = styled.div`
  background-color: var(--Dove);
  padding: 16px 24px 0 24px;
  display: flex;
  height: 56px;
  background-color: var(--Dove);
  margin-bottom: 1px;
  @media (max-width: 600px) {
    justify-content: center;
  }
`
const Anchor = styled.a`
  color: blue !important;
`

const UnderLine = styled.div`
  width: 32px;
  height: 2px;
  border-radius: 2px;
  background-color: ${({ active }) => active ? 'var(--Azure500)' : 'none'};
`
const WalletDiv = styled.div`
  padding: 24px;
  background-color: var(--Dove);
  margin-bottom: 2px;
`

const card = {
  backgroundColor: 'surface.foreground',
  p: '16px',
  display: 'flex',
  alignItems: 'center',
  mb: '4px'
}

const SpanTag = styled.span`
  font-size: 28px;
  @media (max-width: 600px) {
    font-size: 20px;
  }
`

export {
  CardDiv,
  Tab,
  TabNameSpan,
  TopWalletSection,
  Anchor,
  TabsHolder,
  EarningText,
  TotalEarningLabel,
  SingleDivSection,
  IncomeRightSection,
  BalanceRightSection,
  UnderLine,
  WalletDiv,
  card,
  SpanTag
}